import { Component, ElementRef, Inject, OnInit, Output, ViewChild, Renderer2 } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable, Subject } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { GerencianetService } from 'src/services/gerencianet.service';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { CustomValidators } from 'src/validators';
import * as STATES from 'src/assets/states.json';
import { ViaCepService } from 'src/services/via-cep.service';
import * as accents from 'remove-accents';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ChangeDetectorRef } from '@angular/core';
//import * as PAYMENT_TOUR from 'src/assets/tuor/payment.json';

const CARD_ERRORS = {
  3500062: 'Data de expiração inválida, tente novamente',
  3500058: 'Número de cartão inválido'
}

@Component({
  selector: 'app-checkout-dialog',
  templateUrl: './checkout-dialog.component.html',
  styleUrls: ['./checkout-dialog.component.scss']
})
export class CheckoutDialogComponent implements OnInit {

  paymentMethod: string = 'BILLET';
  form: FormGroup;
  @Output() formObserver: Subject<FormGroup>;
  formVoucher: FormGroup;
  submitingCardBrand: boolean = false;
  submiting: boolean = false;
  submitted: boolean = false;
  processListName: string = null;
  processListVoucher: string = null;
  enableVoucher: boolean = true;
  planType: string = 'PERSONAL';
  boletoUrl: SafeResourceUrl;
  user: any;
  anno: any;
  private signaturePlan: any = null;
  errorsAttemps: number = 0;
  showContent = false;
  methodPay = true;
  currentUser: any;
  states: Array<any> = (STATES as any).default;
  cities: Array<any> = [];
  filteredStates$: Observable<any>;
  filteredCities$: Observable<any>;
  @ViewChild('focarCPF') focarCPF: ElementRef;
  message: string = 'Digite o código do cupom e ganhe mais três meses de acesso gratuito.';
  success: boolean = false;

  constructor(
    fb: FormBuilder,
    private snackbar: MatSnackBar,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private dialogRef: MatDialogRef<CheckoutDialogComponent>,
    private gerencianet: GerencianetService,
    private viaCep: ViaCepService,
    private sanitizer: DomSanitizer,
    private readonly cd: ChangeDetectorRef,
    private renderer: Renderer2,
    private el: ElementRef,
    @Inject(MAT_DIALOG_DATA) data: any
  ) {

    this.user = JSON.parse(localStorage.getItem('token'));
    this.boletoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.user.payment_link);

    if (!this.user.signature_date) {
      this.showContent = true;
    }

    this.currentUser = JSON.parse(localStorage.getItem('token'));
    this.form = fb.group({
      brandCard: [null],
      cardNumber: [null, Validators.required],
      holderName: [null, Validators.required],
      cvv: [null, Validators.required],
      expirationDate: [null, Validators.required],
      zipCode: [null, [CustomValidators.cep]],
      email: [null, [Validators.required, Validators.email]],
      state: [null, Validators.required],
      stateName: [null],
      city: [null, Validators.required],
      district: [null, Validators.required],
      street: [null, Validators.required],
      number: [null, Validators.required],
      complement: [null],
      fullname: [null, Validators.required],
      birthdate: [null],
      phone: [null, Validators.required],
      cpf: [null],
      cnpj: [null, [Validators.required, CustomValidators.cnpj]],
      companyName: [null, Validators.required],
      acceptEnd: [false]
    });
    this.formVoucher = fb.group({
      user: [this.user.company_id, Validators.required],
      code: [null, Validators.required]
    })
    this.formObserver = new Subject<FormGroup>();

    if (data) {
      this.processListName = data.processListName;
      this.processListVoucher = data.processListVoucher;
      this.enableVoucher = !!data.processListVoucher;
    }

    this.planType = this.user.company_id ? 'BUSINESS' : 'PERSONAL';

  }

  toggleContent() {
    this.showContent = !this.showContent;
    this.methodPay = !this.methodPay;
    setTimeout(() => {
      this.buscainfo();
    }, 1000);
  }

  ngAfterViewInit() {
    //this.anno.show()

    if (this.user.signature_date) {
      setTimeout(() => {
        this.choosePlan(this.signaturePlan);
      }, 1000);
    } else {
      this.choosePlan(this.signaturePlan);
      setTimeout(() => {
        this.buscainfo();
      }, 1000);
    }

    setTimeout(() => {
      this.onAcceptEndChange();
    }, 1000);

  }

  ngOnInit(): void {

    const subject = new Subject<any>();
    subject.subscribe(
      result => {

        const { trigger, scope } = result;

        if ((scope.indexOf('gerencianet:payment') > -1)
        ) {
          this.submiting = trigger === 'pre';
        }

      }

    )

    this.http.setLoadingIndicator(subject);

    this.form.get('cardNumber')
      .valueChanges
      .pipe(debounceTime(1000))
      .subscribe(
        cardNumber => {

          const cardBrand = this.form.get('brandCard').value;
          const form = this.form;

          if (cardNumber && cardNumber.length >= 6 && cardBrand === null) {

            const subject = new Subject<any>();
            subject.subscribe(
              cardBrand => {
                if (cardBrand)
                  form.get('brandCard').setValue(cardBrand);
                else form.get('brandCard').setValue(null);
              }
            )
            this.gerencianet.getCardBrand(cardNumber, subject);

          }

          if (cardNumber && cardNumber.length < 6)
            form.get('brandCard').setValue(null)

        }
      )

    this.formObserver.next(this.form);
    this.form.get('zipCode')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(
        cep => {
          if (!this.form.get('zipCode').invalid) {
            this.viaCep.getLocation(cep)
              .subscribe(
                data => {
                  if (data) {
                    if (data.erro) {
                      alert('CEP inválido por favor tente novamente');
                      this.form.patchValue({
                        zipCode: ''
                      });
                    } else {
                      const { bairro, localidade, logradouro, uf } = data;
                      const state = this.states.find(state => state
                        ? state.sigla.toLowerCase() ===
                        uf.toLowerCase() : null);

                      this.form.patchValue({
                        district: bairro,
                        city: localidade,
                        street: logradouro,
                        state: uf,
                        // state: state ? state.sigla : null,
                        stateName: state ? accents.remove(state.nome) : null,
                        email: localStorage.getItem('email')
                      }, { emitEvent: false });
                    }
                  }
                }
              )
          }
        }
      )

    this.filteredStates$ = this.form.get('state')
      .valueChanges
      .pipe(
        map(state => this._filterStates(state))
      );

    this.filteredCities$ = this.form.get('city')
      .valueChanges
      .pipe(map(city => this._filterCities(city)));

  }

  buscainfo() {

    this.http.get('profile:info', { id: this.currentUser.id })
      .subscribe(
        (result: any) => {

          const { type, data } = result;
          if (type === 'OK') {
            for (const key in data) {
              const value = data[key];
              if (value === 'undefined')
                data[key] = null;
            }

            if (data.companycity !== null && data.companycity.split(',').length > 1) {
              var uf = data.companycity?.split(',')[1].trim() ?? '';
              var cidade = data.companycity?.split(',')[0].trim() ?? '';
              var estado = this.states.find(estado => estado.sigla.trim() === uf);
            } else {
              var estado = data.companystate;
              var cidade = data.companycity;
            }

            let namefull: string;

            if (data.lastname !== null) {
              namefull = data.firstname + ' ' + data.lastname;
            } else {
              namefull = data.firstname;
            }

            this.form.patchValue(
              {
                companyName: data.companyname,
                cnpj: data.cnpj,
                cpf: data.cpf,
                birthdate: data.birthdate,
                phone: data.phone,
                gender: data.gender,
                zipCode: data.companyzipcode,
                state: uf,
                city: cidade,
                district: data.district,
                street: data.companyaddress1,
                number: data.companyaddress2,
                complement: data.complement,
                email: data.email,
                fullname: namefull
              },
              { emitEvent: false }
            );

            if (!this.form.valid) {
              this.form.markAllAsTouched();
            }

          }

        }
      )

  }

  onAcceptEndChange() {
    const controls = ['brandCard', 'cardNumber', 'holderName', 'cvv', 'expirationDate'];

    if (this.paymentMethod === 'CREDIT_CARD') {
      controls.forEach(control => {
        this.form.get(control).enable();
        this.form.get(control).setValidators(Validators.required);
        this.form.get(control).updateValueAndValidity();
      });
    } else {
      controls.forEach(control => {
        this.form.get(control).disable();
        this.form.get(control).clearValidators();
        this.form.get(control).updateValueAndValidity();
      });
    }
  }

  submitCode() {

    const isValid = !this.formVoucher.invalid;

    if (isValid) {

      const data = this.formVoucher.getRawValue();

      // if (this.processListVoucher && (data.code !== this.processListVoucher)) {

      //   alert('Esse código do cupom não pertence a essa empresa');
      //   this.dialogRef.close()
      //   return;

      // }
      // this.http.save('candidate:voucher', data)

      this.http.save('company:cupom', data)
        .subscribe(
          (result: any) => {

            if (result.type === 'OK') {
              this.submiting = true;
              const threeMonthsLater = new Date();
              threeMonthsLater.setMonth(threeMonthsLater.getMonth() + 3);
              this.success = true;

              this.formVoucher.get('code').disable();
              this.formVoucher.get('code').setErrors(null);
              this.formVoucher.get('code').markAsUntouched();
              this.message = `Seu cupom foi validado com sucesso e sua próxima fatura vencerá em ${threeMonthsLater.toLocaleDateString()}.`;
              this.snackbar.open(' Seu cupom foi validado com sucesso !!!', 'OK', { duration: 3000 });

              //localStorage.setItem('activeVoucher', data.code);
              // this.snackbar.open('Seu cupom foi aceito. Os três meses grátis serão incluídos no método de pagamento.', 'OK', { duration: 5000 })
              //this.dialogRef.close(true);
              setTimeout(() => {
                if (this.success) {
                  const outline = this.el.nativeElement.querySelector('.mat-form-field-appearance-outline.mat-form-field-disabled .mat-form-field-outline');
                  const outline2 = this.el.nativeElement.querySelector('.mat-form-field-label');
                  const outline3 = this.el.nativeElement.querySelector('.mat-form-field-infix input');
                  if (outline) {
                    this.renderer.setStyle(outline, 'color', 'rgb(14, 219, 14)');
                    this.renderer.setStyle(outline, 'background', '#e5fbe4');
                    this.renderer.setStyle(outline2, 'color', 'rgb(14, 219, 14)');
                    this.renderer.setStyle(outline3, 'font-size', '20px');
                    this.renderer.setStyle(outline3, 'color', '#0edb0e');
                    this.renderer.setStyle(outline3, 'font-weight', '800');
                  }
                }
              }, 200);

            } else if (result.type === 'FAIL') {
              this.formVoucher.get('code').setValue(null);
              this.snackbar.open('Seu código inválido ou já foi utilizado, tente com um código válido ou efetue o pagamento', 'OK', { duration: 5000 })
              this.submiting = false;
              this.success = false;

            }

          },
          err => this.errorReport.showMessage(err),
          () => this.submiting = false
        );

    }

  }

  viewPayment(email: string) {

    const data = email;

    this.http.get('candidate:statuspay', { email: data })
      .subscribe(
        (result: any) => {

          if (result.type === 'OK') {

            const user = JSON.parse(localStorage.getItem('token'));
            user.signature_status = 'ACTIVE';
            localStorage.setItem('token', JSON.stringify(user));
            this.snackbar.open('Pagamento Confirmado', 'OK', { duration: 3000 })
            this.dialogRef.close(true);

          } else if (result.type === 'FAIL') {
            this.snackbar.open('Ainda estamos aguardando a confirmação do seu pagamento. tente novamente mais tarde', 'OK', { duration: 3000 })
          }

        },
        err => this.errorReport.showMessage(err)
      );

  }

  choosePlan(args) {
    this.signaturePlan = args;
  }

  logout() {

    const message = 'Deseja realmente sair da sua conta?';
    if (!confirm(message))
      return;

    localStorage.removeItem('token');
    localStorage.clear();
    setTimeout(() => window.location.reload(), 2000);

  }

  submit() {
    this.paymentData();
    if (this.paymentMethod == 'BILLET') {
      this.submitBillet();
    } else {
      this.submitCreditCard();
    }

  }

  changePaymentMethod(args: MatTabChangeEvent) {
    this.paymentMethod = args.index > 0 ? 'CREDIT_CARD' : 'BILLET';
    // console.log('metodo pag:', this.paymentMethod);
    this.onAcceptEndChange();
  }

  paymentData() {

    const user = JSON.parse(localStorage.getItem('token'));
    const data = this.form.getRawValue();
    data.userId = user.id;
    data.payment_type = this.paymentMethod;

    this.http.save('company:paymentinfo', data)
      .subscribe(
        (result: any) => {

          if (result.type === 'OK') {
            //console.log('dados salvos');
          } else if (result.type === 'FAIL') {
            console.error('erro ao salvar os dados');
          }

        },
        err => this.errorReport.showMessage(err)
      );

  }

  submitBillet() {

    const submitSubject = new Subject<any>();
    const data = { ...this.form.getRawValue() };

    submitSubject.subscribe(
      result => {

        if (result === true)
          this.submiting = true;
        else if (result.type === 'OK') {

          this.submiting = false;
          const user = JSON.parse(localStorage.getItem('token'));
          const { data: { id, link } } = result;

          user.signature_id = id;
          if (user.signature_date == null) {
            user.signature_status = 'ACTIVE';
          }
          localStorage.setItem('token', JSON.stringify(user));

          this.submitted = true;
          if (this.signaturePlan && this.signaturePlan.code !== 'MONTHLY')
            window.open(link, '_blank');

          setTimeout(() => window.location.reload(), 3000);

        }

      },
      err => {
        this.submiting = false;
        this.snackbar.dismiss();
        const { code } = err;

        if (CARD_ERRORS[code] == null && this.errorsAttemps < 5) {

          this.submitBillet();
          this.errorsAttemps++;

        } else {

          const message = CARD_ERRORS[code] || 'Ocorreu um erro desconhecido, verifique os dados informado e tente novamente';
          this.snackbar.open(message, 'OK', { duration: 3000 });

        }
      }
    )

    data['signaturePlanId'] = this.signaturePlan.code;

    if (this.errorsAttemps == 0)
      this.snackbar.open('Gerando seu boleto para pagamento, você será redirecionado para a impressão do boleto em seguida', 'OK');

    this.gerencianet.tryPaymentBillet(data, submitSubject);

  }

  submitCreditCard() {

    const isValid = !this.form.invalid;

    if (isValid) {

      const data = this.form.getRawValue();
      data.signature_plan_id = this.signaturePlan.code;
      const submitSubject = new Subject<any>();

      submitSubject.subscribe(
        result => {

          if (result === true)
            this.submiting = true;
          else {

            this.submiting = false;
            const user = JSON.parse(localStorage.getItem('token'));
            user.signature_id = result.data;
            if (user.signature_date == null) {
              user.signature_status = 'ACTIVE';
            }
            localStorage.setItem('token', JSON.stringify(user));

            this.submitted = true;
            setTimeout(() => window.location.reload(), 8000);

          }

        },
        err => {

          this.submiting = false;
          this.snackbar.dismiss();
          const { code } = err;


          const message = CARD_ERRORS[code] || 'Ocorreu um erro desconhecido, verifique os dados informado e tente novamente';
          this.errorReport.showMessage(err, message);
          this.snackbar.open(message, 'OK', { duration: 3000 });


        }
      )

      this.snackbar.open('Seu cartão será processado pela operadora', 'OK');
      this.gerencianet.tryPayment(data, submitSubject);

    }

  }

  ngOnDestroy() {

    this.gerencianet.unsubscribe();

  }

  onCompleteInput(args, nextInput = null) {

    const { target: { maxLength, value } } = args;

    if (value && (value.length >= maxLength) && nextInput) {

      const input = document.getElementById(nextInput);
      input.focus();

    }

  }

  makeFreeAccount() {

    const user = JSON.parse(localStorage.getItem('token'));
    const data = {
      email: user.email,
      free: 1
    };
    this.http.save('profile:make_paid', data)
      .subscribe(
        (result: any) => {

        },
        (err: any) => console.error('ERR', err)
      )

  }

  public onStateSelected(args: MatAutocompleteSelectedEvent) {

    const { option: { value } } = args;

    this.form.get('stateName').setValue(accents.remove(value.nome));
    this.http.list('locality:city', { initials: value.sigla })
      .subscribe(
        (cities: any) => {
          this.cities = cities;
        }
      );

  }

  private _filterCities(city) {
    if (city) {
      city = city.toLowerCase();
      return this.cities.filter(_city => _city.name.toLowerCase().indexOf(city) > -1);
    }
  }

  private _filterStates(state) {

    if (typeof state !== 'string') return;

    let name = accents.remove(state.toLowerCase());
    return this.states.filter(_state => accents.remove(_state.nome).toLowerCase().indexOf(name) > -1
      || _state.sigla.toLowerCase().indexOf(name) > -1);

  }

}
